import { render, staticRenderFns } from "./OpenSanadBtn.vue?vue&type=template&id=c123afac"
import script from "./OpenSanadBtn.vue?vue&type=script&lang=js"
export * from "./OpenSanadBtn.vue?vue&type=script&lang=js"
import style0 from "./OpenSanadBtn.vue?vue&type=style&index=0&id=c123afac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports